<!--自定义打印-->
<template>
<el-dialog :title="msg('自定义打印')" :visible.sync="visible" :fullscreen="isMinScreen" 
        :close-on-click-modal="false" 
        width="500px">
    <div class="row-wrap">
        
        <el-row>
            <el-col :gutter="10" :xs="24" :sm="8">
                <label class="el-form-item__label">样式：</label>
            </el-col>
            <el-col :gutter="10" :xs="24" :sm="16">
                <el-input type="text" @keyup.enter.native="getPrintData()" v-model="yangshi"></el-input>
            </el-col>
        </el-row>
        <div style="text-align:center; margin-top:10px;">
            <el-button type="primary" icon="iconfont icon-dayin" size="mini"
                @click="getPrintData()" 
            >{{msg('打印')}}</el-button>
        </div>
       
        <template  v-if="msgs">
            <div style="max-height:250px; overflow:scroll;">
                <table class="msg-table" >
                    <thead>
                        <tr>
                            <th>{{msg('单号')}}</th>
                            <th>{{msg('消息')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(key, idx) in msgs" :key="idx">
                            <td>{{idx}}</td>
                            <td>{{key}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
        <template v-if="pages && pages.length>0" >
            
             <vue-easy-print tableShow ref="easyPrint">
                <template>
                    <div v-for="(page, index) in pages" :key="index">
                        <div style="page-break-before: always;" v-if="index>0"></div>
                        <span v-html="page"></span>
                    </div>
                </template>
            </vue-easy-print>
        </template>
       
        <div style="text-align:center; margin-top:10px;" >
            <el-button type="primary" icon="iconfont icon-dayin" size="mini"
                @click="getPrintData()" 
            >{{msg('打印')}}</el-button>
            <el-button type="danger" size="mini" icon="iconfont icon-ziyuan157" v-on:click="close()">{{msg('关闭')}}</el-button>
        </div>
    </div>
</el-dialog>
</template>

<script>
import vueEasyPrint from "vue-easy-print";
export default {
    name: "PrintCustom",
    components: {
        vueEasyPrint: vueEasyPrint,
    },
    data(){
        return {
            visible: false,
            yangshi: null,
            pages: null,
            msgs: null,
            stockIds: null,
        }
    },
    computed: {
        isMinScreen: { //是否小屏幕，浏览器
            get() {
                return this.$store.state.isMinScreen;
            }
        },
    },
    methods: {
        showDialog(stockIds){
            this.msgs = null;
            this.pages = null;
            this.yangshi = null;
            this.stockIds = stockIds;
            this.visible = true;
        },
        close(){
            this.visible = false;
        },
        getPrintData(){
            //获取打印页面
            this.$axios.post(this.$kit.api.print.printCustom
                +"?ids="+this.stockIds.join(",")
                +"&yangshi="+(encodeURIComponent(this.yangshi) || "")
            ).then((result) => {
                if (result.status) {
                   let data = result.data;
                   this.msgs = data.msgs;
                   this.pages = data.pages;
                   this.doPrint();
                }else{
                    this.$message(result.msg);
                }
            });
        },
        doPrint(){
            let len = this.pages.length || 0;
            this.$nextTick(()=>{
                this.$refs.easyPrint.$nextTick(() => {
                    setTimeout(()=>{
                        this.$refs.easyPrint.print();
                    }, (2+(len>100? (len - 100)/100 : 0))*1000);
                });
            });
        }
    }

}

</script>


<style lang="scss" scoped>
.msg-table{margin: 15px 0px; color: #606266; font-size:14px; width:100%;}
.msg-table td {
    border-bottom: 1px solid #EBEEF5;
}
.msg-table th {
    text-align:left;
    border-bottom: 1px solid #EBEEF5;
}
.msg-table{
    border-color:EBEEF5;
}
</style>